import React, { useState } from 'react';


function OneItemOfShop({ item, handleBlur  }) {
    const imageSource = 'https://abcnet.cz/taxi/shop/img/' + item.img;
    const [price, setPrice] = useState(item.price)
   
    return (
        <div style={styles.card}>
     
                <img src={imageSource} style={styles.image} alt="Product" />
                <div style={styles.bigText}>{item.name}</div>
    
                <div style={styles.spaceBetween}></div>
                <div style={{ color: 'red', fontSize: 18, fontWeight: 'bold', textAlign: 'center', marginBottom: 10 }}>
                    <input style={styles.input} type="number" value={price} onChange={(e)=> setPrice(e.target.value)}  onBlur={()=>handleBlur(item.id, price)}/>Kč
                </div>
      

        </div>
    );
}

export default OneItemOfShop;

const styles = {
    card: {
        padding: 7,
        backgroundColor: 'white',
        borderRadius: 15,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
        marginTop: 10,
        marginRight: 5,
        marginBottom: 20,
        width: 140,
        justifyContent: 'space-between'
    },
    imageButton: {
        justifyContent: 'space-between',
        flex: 1
    },
    image: {
        width: 120,
        height: 120, // Nebo jakákoliv výchozí výška
        objectFit: 'contain'

    },
    row: {
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row'
    },
    button: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '95%',
        height: 33,
        backgroundColor: '#27ae60',
        borderRadius: 5,
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.3)',
    },
    smallButton: {
        backgroundColor: '#27ae60',
        height: 33,
        width: 33,
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center',
    },
    smallButtonMinus: {
        backgroundColor: 'white',
        border: '1px solid grey',
        height: 33,
        width: 33,
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center'
    },
    countContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    count: {
        backgroundColor: '#eee',
        width: 28,
        height: 33,
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center'
    },
    spaceBetween: {
        flex: 1
    },
    bigText: {
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center'
    },
    input: {
        border: 'none',
        width: 60,
        fontSize: 20
    }
};
